function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.75,
  cy: 40,
  r: 40,
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.75,
  cy: 40,
  r: 40,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 -14.9768L80.75 -15L80.7442 11.6929C78.3171 14.9945 74.2472 16.3875 68.5343 15.8719C59.9649 15.0988 44.9198 8.13749 27.9438 8.13749C16.6264 8.13749 7.56184 11.8028 0.75 19.1333V-14.9768Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M60.7318 37.0588C59.2251 37.0588 57.8774 37.7258 56.9576 38.7774C56.2802 38.375 55.6029 37.9921 54.9239 37.6405C54.9263 37.5953 54.937 37.5528 54.937 37.5068C54.937 36.3119 53.9679 35.3433 52.7723 35.3433C52.1699 35.3433 51.6259 35.5909 51.2334 35.9889C44.2581 33.3393 37.1832 33.337 30.2078 35.9822C29.8162 35.5877 29.2745 35.3433 28.6745 35.3433C27.4793 35.3433 26.5102 36.3119 26.5102 37.5068C26.5102 37.5492 26.5198 37.5889 26.5233 37.631C25.8527 37.977 25.1833 38.3544 24.5162 38.7496C23.5968 37.7151 22.2599 37.0592 20.7674 37.0592C17.9956 37.0588 15.75 39.3048 15.75 42.0762C15.75 44.8472 17.9956 47.0936 20.7678 47.0936C23.5384 47.0936 25.7852 44.8476 25.7852 42.0762C25.7852 41.398 25.6487 40.7524 25.4059 40.1627C26.0098 39.8071 26.6138 39.4671 27.2197 39.1544C27.8995 46.767 33.638 52.7059 40.5954 52.7059C47.5025 52.7059 53.2037 46.8511 53.9513 39.3179C54.0314 39.2651 54.1049 39.2024 54.1779 39.1397C54.814 39.4675 55.4477 39.8234 56.0814 40.198C55.8461 40.7786 55.7148 41.4115 55.7148 42.0762C55.7148 44.8472 57.9604 47.0936 60.7322 47.0936C63.5032 47.0936 65.75 44.8476 65.75 42.0762C65.7496 39.3048 63.5032 37.0588 60.7318 37.0588ZM20.7678 42.4178C19.6595 42.4178 18.7599 41.5194 18.7599 40.4111C18.7599 39.3024 19.6595 38.404 20.7678 38.404C21.8757 38.404 22.7745 39.3024 22.7745 40.4111C22.7742 41.519 21.8757 42.4178 20.7678 42.4178ZM40.3327 51.5201C38.6609 51.5201 37.2185 50.5928 36.4558 49.2317C36.2546 48.8737 36.0907 48.4924 35.9947 48.0821C34.7995 47.4861 33.9772 46.2519 33.9772 44.825C33.9772 42.8159 35.6058 41.1873 37.6153 41.1873C38.707 41.1873 39.6851 41.6686 40.3526 42.4305C41.0196 41.6686 41.9978 41.1873 43.0891 41.1873C45.0982 41.1873 46.7271 42.8159 46.7271 44.825C46.7271 46.2698 45.8847 47.5178 44.6645 48.1051C44.5402 48.6261 44.318 49.1075 44.0283 49.5396C43.2295 50.7317 41.876 51.5201 40.3327 51.5201ZM47.6057 47.1924C47.7755 46.6174 47.8747 46.0154 47.8747 45.3912C47.8747 44.5932 47.7243 43.8278 47.4505 43.1147C48.0993 42.7079 48.5311 41.9869 48.5311 41.1651C48.5311 39.8944 47.5017 38.8647 46.2311 38.8647C45.5398 38.8647 44.9212 39.1699 44.4994 39.652C43.3101 38.9322 41.8855 38.5115 40.353 38.5115C38.8197 38.5115 37.3951 38.9322 36.2062 39.652C35.7844 39.1695 35.1657 38.8647 34.4745 38.8647C33.2038 38.8647 32.1745 39.8944 32.1745 41.1651C32.1745 41.9869 32.6062 42.7079 33.255 43.1147C32.9812 43.8278 32.8308 44.5936 32.8308 45.3912C32.8308 45.7714 32.8729 46.1416 32.9384 46.5047C31.2618 44.5873 30.1201 42.0801 29.7729 39.3615C30.3971 38.9909 30.8209 38.3203 30.8348 37.5433C37.3971 35.0822 44.0526 35.0854 50.6156 37.5516C50.6295 38.2222 50.9505 38.8119 51.4418 39.1988C51.0799 42.319 49.6688 45.173 47.6057 47.1924ZM60.7318 42.4178C59.6227 42.4178 58.7251 41.5194 58.7251 40.4111C58.7251 39.3024 59.6227 38.404 60.7318 38.404C61.8401 38.404 62.7389 39.3024 62.7389 40.4111C62.7389 41.519 61.8401 42.4178 60.7318 42.4178Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M43.0895 45.7606C43.6063 45.7606 44.0252 45.3416 44.0252 44.8249C44.0252 44.3081 43.6063 43.8892 43.0895 43.8892C42.5727 43.8892 42.1538 44.3081 42.1538 44.8249C42.1538 45.3416 42.5727 45.7606 43.0895 45.7606Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M37.6156 45.7606C38.1324 45.7606 38.5513 45.3416 38.5513 44.8249C38.5513 44.3081 38.1324 43.8892 37.6156 43.8892C37.0989 43.8892 36.6799 44.3081 36.6799 44.8249C36.6799 45.3416 37.0989 45.7606 37.6156 45.7606Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M42.1136 48.0325C41.7672 48.5377 41.066 49.1278 40.2256 49.1278C39.3847 49.1278 38.6839 48.5381 38.3375 48.0325C38.2089 47.8424 37.9502 47.7944 37.7593 47.9242C37.5696 48.054 37.5208 48.3127 37.6514 48.5028C38.1327 49.2075 39.0621 49.9607 40.2256 49.9607C41.389 49.9607 42.318 49.2079 42.7993 48.5028C42.9295 48.3127 42.8807 48.054 42.6914 47.9242C42.5017 47.7944 42.2426 47.8424 42.1136 48.0325Z",
  fill: "black"
});

var SvgNewPlan = function SvgNewPlan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 80
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -15,
    width: 81,
    height: 35
  }, _ref4), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 13.4673V18.4614L40.75 15.9644L0.75 13.4673Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8058 15.9268L40.8156 15.9189L40.7979 15.9207L40.7917 15.9251L40.8058 15.9268Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9001 15.9324L80.75 18.4197V13.4275L41.0245 15.9058L40.9001 15.9324Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7838 15.9254L40.7874 15.9209L40.7767 15.9218L40.775 15.9245L40.7838 15.9254Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7579 15.9224H40.7526V15.9243H40.7579V15.9224Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8505 15.9298L40.8957 15.9138L40.8407 15.9172L40.8202 15.9279L40.8505 15.9298Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7677 15.9199H40.7651V15.927H40.7677V15.9199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 24.4789V29.831L40.75 15.9644L0.75 24.4789Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 15.9642L40.9002 15.9322L40.8505 15.9297L40.75 15.9642Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0244 15.9057L80.75 7.44978V2.09863L40.8958 15.9138L41.0244 15.9057Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8958 15.9139L40.8503 15.9299L40.9 15.9324L41.0244 15.9058L40.8958 15.9139Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8946 31.6591L40.75 15.9644L10.5713 31.6591H17.8946Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8406 15.917L80.75 -4.83837V-11.5034L40.8157 15.919L40.8406 15.917Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8059 15.927L40.75 15.9643L40.8202 15.9279L40.8059 15.927Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8202 15.9279L40.8407 15.9172L40.816 15.9192L40.8062 15.9271L40.8202 15.9279Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3684 31.6591L40.7499 15.9644L23.7343 31.6591H27.3684Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.798 15.9207L80.75 -20.9293V-25.6392H76.2224L40.7874 15.9207H40.798Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7837 15.9253L40.75 15.9643L40.7918 15.9253H40.7837Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7918 15.9254L40.798 15.9209H40.7873L40.7837 15.9254H40.7918Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2054 31.6591L40.7499 15.9644L30.7866 31.6591H33.2054Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7766 15.9215L67.1586 -25.6392H60.7523L40.7695 15.9215H40.7766Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7686 15.9243L40.75 15.9642L40.775 15.9243H40.7686Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7748 15.9199H40.7714V15.927H40.7748V15.9199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6613 31.6591L40.75 15.9644L35.7202 31.6591H37.6613Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7633 15.9224L54.0836 -25.6392H48.9367L40.7579 15.9224H40.7633Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7579 15.9243L40.75 15.9642L40.7632 15.9243H40.7579Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7615 15.9209H40.7598V15.9262H40.7615V15.9209Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6571 31.6591L40.75 15.9644L39.844 31.6591H41.6571Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7525 15.9243L40.7499 15.9235L40.7525 15.9224L43.1502 -25.6392H38.3506L40.7499 15.9642L40.7525 15.9243Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 15.9234L40.7524 15.9242V15.9224L40.75 15.9234Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7806 31.6591L40.75 15.9644L43.8386 31.6591H45.7806Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5641 -25.6392H27.4172L40.7499 15.9642L32.5641 -25.6392Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7125 31.6591L40.75 15.9644L48.2954 31.6591H50.7125Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7496 -25.6392H14.3413L40.7501 15.9642L20.7496 -25.6392Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7665 31.6591L40.75 15.9644L54.1307 31.6591H57.7665Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27774 -25.6392H0.75V-20.9302L40.75 15.9642L5.27774 -25.6392Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9279 31.6591L40.75 15.9644L63.6055 31.6591H70.9279Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 -11.5034V-4.83837L40.75 15.9642L0.75 -11.5034Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75 29.831V24.4789L40.75 15.9644L80.75 29.831Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2.09766V7.44968L40.75 15.9642L0.75 2.09766Z",
    style: {
      fill: "var(--color-primary)"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 40.75,
    cy: 46.2,
    r: 11,
    style: {
      fill: "var(--color-primary)"
    }
  }), _ref5, _ref6, _ref7, _ref8));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewPlan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new-plan.3be7e7b7.svg";
export { ForwardRef as ReactComponent };